mod.modules.define("MobileDetect", function (fn) {
	// https://github.com/codefuze/js-mobile-tablet-redirect
	function mobile_detect(mobile, tablet, mobile_redirect, tablet_redirect, debug) {
		var ismobile = (/iphone|ipod|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase()));
		var istablet = (/ipad|android 3|sch-i800|playbook|tablet|kindle|gt-p1000|sgh-t849|shw-m180s|a510|a511|a100|dell streak|silk/i.test(navigator.userAgent.toLowerCase()));

		if (debug == true) {
			alert(navigator.userAgent);
		}

		if (debug == true) {
			alert(document.cookie);
		}

		if (ismobile && mobile == true) {
			if (debug == true) {
				alert("Mobile Browser");
			}

			window.location = mobile_redirect;
		}
		else if (istablet && tablet == true) {
			if (debug == true) {
				alert("Tablet Browser");
			}

			window.location = tablet_redirect;
		}		
	}

	// Redirect if mobile, but not if they clicked on the View Full Site link.
	fn.prototype.init = function (params) {
		var redirectToMobile = true;

		// get the cookie
		var name = "vlMobile.ViewFullSiteClicked=";
		var ca = document.cookie.split(';');

		//alert(ca);

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1);
			if (c.indexOf(name) != -1) {
				var value = c.substring(name.length, c.length);
				if (value == "fullsite" || value == "prosite") {
					// if the cookie is found, then set the redirect flag.
					redirectToMobile = false;
				}
			}
		}

		var pathIsLandingPage = false;
		if (window.location.pathname == '/') { //
			pathIsLandingPage = true;
		}

		// if the redirectflag is set to true, then redirect to the mobile site.
		if (redirectToMobile && pathIsLandingPage) {
			var redirectUrl = "~/mobile/".resolveUrl();
			mobile_detect(true, false, redirectUrl, redirectUrl, false);
		}
	}
});